import store from "@/store";

export default function hasAnyWeightLossProgram({ next }) {
  const hasAnyWeightLossProgram = store.getters["user/hasAnyWeightLossProgram"];

  if (hasAnyWeightLossProgram) {
    return next();
  }

  return (window.location = `${process.env.VUE_APP_LANDING_PAGE}/offer/weight-loss-programme-getlabtest`);
}
